<template>
  <div>

    <el-dialog size="tiny" class="express-dialog" v-model="modalDisplay" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" @close="modalClose" @open="modalOpen">

      <div class="el-dialog__header custom-header">
        <span class="el-dialog__title">{{dialogTitle[step]}}</span>
        <div class="el-dialog__headerbtn" @click="modalClose">
          <i class="el-dialog__close el-icon el-icon-close"></i>
        </div>
      </div>

      <div class="express-type-select" v-show="step === 0 ">
        <div class="express-type-tips">
          <img src="../assets/imgs/fg_offline_notice.png" />
          为保障资料的安全性和时效性，建议使用顺丰快递
        </div>
        <div class="content">
          <div class="sf-pick-up express-card" @click="goSFPickUpPage(dataModel)">
            <div class="recomend">
              <img src="../assets/imgs/recomend.png" alt="recomend">
            </div>
            <div class="sf-icon inline-top">
              <img src="../assets/imgs/sf-express.png" alt="SF">
            </div>
            <div class="sf-content inline-top">
              <div class="express-title">顺丰上门取资料</div>
              <div class="express-content">无需填单省时省心</div>
            </div>
          </div>
          <div class="self-send express-card" @click="goToExpressDetail">
            <div class="self-send-icon inline-top">
              <img src="../assets/imgs/other-express-type.png" alt="other-express">
            </div>
            <div class="self-send-content inline-top">
              <div class="express-title">自行邮寄</div>
              <div class="express-content">自助填单联系快递</div>
            </div>
          </div>
        </div>
      </div>

      <div class="enter-express-info" v-show="step === 1">
        <div class="express-to-address">
          <div class="title">邮寄资料到该地址</div>
          <div class="content">
            <div class="location-icon">
              <img src="../assets/imgs/express-location.png" alt="location">
            </div>
            <div class="right-content">
              <div class="express-name">
                <span class="name" v-text="supplierAddress.addressee"></span>
                <span class="name">（{{country + '，' + User.peer.visa_peer_id}}）</span>
                <span class="tel" v-text="supplierAddress.mobile_phone"></span>
              </div>
              <div class="express-detail">
                <span v-text="getAddress(pcds, supplierAddress)"></span>
              </div>
            </div>
          </div>
        </div>
        <div class="enter-express-tips">
          *为保障资料的安全性和时效性，建议使用顺丰快递
        </div>
        <el-form :model="express" label-width="80px" :rules="rules" class="no-required" ref="dataForm">
          <el-form-item  prop="express_name">
            <el-select class="express-select" v-model="express.express_name" placeholder="请选择快递公司">
              <el-option label="顺丰" value="shunfeng"></el-option>
              <el-option label="申通" value="shentong"></el-option>
              <el-option label="中通" value="zhongtong"></el-option>
              <el-option label="汇通" value="huitongkuaidi"></el-option>
              <el-option label="圆通" value="yuantong"></el-option>
              <el-option label="韵达" value="yunda"></el-option>
              <el-option label="EMS" value="EMS"></el-option>
              <el-option label="其他" value="other"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item  prop="other_express_name" v-if="express.express_name === 'other'">
            <el-input v-model.trim="express.other_express_name" placeholder="填写快递名称" :maxlength="15"></el-input>
          </el-form-item>
          <el-form-item  prop="tracking_number" style="margin-bottom: 0">
            <el-input v-model.trim="express.tracking_number" placeholder="填写快递单号" :maxlength="15"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="modalClose">取消</el-button>
          <el-button type="primary" @click="beforeExpressAdd(dataModel)">确定</el-button>
        </div>
      </div>

    </el-dialog>
  </div>
</template>

<script>
import MessageModal from '@/components/common/modals/message-modal/message-modal';
import User from '@/libs/user';

import sensorsdata from 'sa-sdk-javascript';
import applicantConstants from '../constants/applicant-constants';
import utils from '../libs/utils';
import Http from '../libs/http';
import addressUtils from '../libs/address-utils';
import validates from '../libs/validates';
import pcdService from '../services/pcd-service';

export default {
  props: {
    orderId: {
      type: Number,
    },
    expressChooseModal: {
      type: Boolean,
    },
    currentStep: {
      type: Number,
      default() {
        return 0;
      },
    },
    applicant: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  created() {
    pcdService.getPcd().then(pcds => this.pcds = pcds).catch((e) => {
      if (e) console.log(e);
    });
  },
  data() {
    return {
      dataModel: {},
      country: '',
      pcds: {},
      supplierAddress: {},
      productId: 0,
      modalDisplay: false,
      step: this.currentStep ? this.currentStep : 0,
      express: {
        express_name: '',
        tracking_number: '',
      },
      rules: {
        express_name: [
          { required: true, message: '请输入正确的快递单号', trigger: 'input' },
        ],
        tracking_number: [
          validates.required(),
          { pattern: /^[0-9a-zA-Z]+$/, message: '请输入正确的快递单号', trigger: 'blur' },
        ],
      },
      dialogTitle: ['选择寄件方式', '填写快递信息'],
      User,
    };
  },
  watch: {
    expressChooseModal(componentShow) {
      this.modalDisplay = componentShow;
      if (componentShow) {
        this.getOrderQueryData();
      }
    },
  },
  methods: {
    // 跳转到顺丰上门取件页面
    goSFPickUpPage(order) {
      if (!order.user_order_id) return;
      this.$router.push({ name: 'sfpickup', params: { oid: order.user_order_id, pid: order.visa_product_id } });
    },
    // 地址处理函数
    getAddress: addressUtils.getAddress,
    // 发货信息校验和处理
    beforeExpressAdd(od) {
      if (!this.express.express_name) {
        utils.msg.warning('请选择快递公司');
        return;
      }
      if (this.express && this.express.express_name === 'other' && !this.express.other_express_name) {
        utils.msg.warning('请输入快递公司');
        return;
      }
      if (!this.express.tracking_number) {
        utils.msg.warning('请输入快递单号');
        return;
      }

      if (this.express && this.express.express_name === 'other' && this.express.other_express_name) {
        this.express.express_name = this.express.other_express_name;
        delete this.express.other_express_name;
      }

      this.expressAdd(od);
    },
    // 新增发货快递信息
    expressAdd(od) {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          const postData = utils.extend({}, this.express, {
            user_order_id: od.user_order_id,
          });

          const otherApplicantList = od.applicant.filter(item => item.order_applicant_id !== this.applicant.order_applicant_id);
          const othersAlsoNotPassed = otherApplicantList.some(item => item.applicant_status === 2 && !item.paper_online_status &&
            (item.material.material_required.some((material) => {
              if (material.attr === 1 && material.express && material.express.length && material.express[0].paper_status === 4) return true;
              return false;
            }) || item.material.material_optional.some((material) => {
              if (material.attr === 1 && material.express && material.express.length && material.express[0].paper_status === 4) return true;
              return false;
            })));

          // 预审不通过时，选择邮寄补充资料的情况
          if (this.applicant.applicant_status === applicantConstants.STATUS.verifyNotPassed_2 && otherApplicantList.length && othersAlsoNotPassed) {

            MessageModal.modal({
              title: '提示',
              message: '是否其他申请人不合格的邮寄资料都通过线下邮寄补充？',
              showCancelButton: true,
              showConfirmButton: true,
              confirmButtonText: '是',
              cancelButtonText: '否',
              confirmMethod: () => {

                this.expressInfoHttp(od, '/order_supplier_express_add', postData);

              },
              cancelMethod: () => {

                this.expressInfoHttp(od, '/applicant_supplier_express_add', {
                  order_applicant_id: this.applicant.order_applicant_id,
                  ...postData,
                });
              },
            });

          } else {

            this.expressInfoHttp(od, '/order_supplier_express_add', postData);
          }
        }
      });
    },

    // 提交快递信息的http请求
    expressInfoHttp(od, url, params) {

      const {
        product_name, country, visa_product_id, visa_type, user_order_id,
      } = od;
      const { peer_account_id } = this.User;

      Http.post(url, params).then(() => {
        // 神策埋点
        sensorsdata.track('AddPaperInfo', {
          peer_account_id,
          online_offline: '线下邮寄',
          country,
          visa_product_id,
          platform_type: 'PC',
          visa_type,
          product_name,
          user_order_id,
        });

        utils.msg.success('快递信息提交成功');
        od.order_status = 5;
        this.modalClose(1);
      }).catch((e) => {
        if (e) console.log(e);
      });
    },

    // 请求order_query的数据
    getOrderQueryData() {
      Http.post('/order_query', { user_order_id: this.orderId }).then((data) => {
        this.dataModel = data;
        this.supplierAddress = data.supplier_address;
        this.orderId = data.user_order_id;
        this.productId = data.visa_product_id;
        this.country = data.country;
      }).catch((e) => {
        if (e) console.log(e);
      });
    },
    // 进入快递信息填写页
    goToExpressDetail() {
      this.step = 1;
    },
    // 关闭弹窗
    modalClose(success) {
      if (success === 1) {
        this.$emit('modalClose', this.orderId);
      }
      this.$emit('modalClose');
      setTimeout(() => {
        this.step = this.currentStep;
        this.express.express_name = '';
        this.express.tracking_number = '';
        this.express.other_express_name = '';
      }, 200);
    },
    // 打开弹窗
    modalOpen() {

    },
  },

};

</script>

<style lang="less">
@import '../assets/less/variable';

.express-dialog {
  .el-dialog {
    width: 480px;
  }
  .el-dialog__header {
    display: none;
  }
  .el-dialog__header.custom-header {
    display: block;
    padding: 0 20px 0;
    height: 60px;
    line-height: 60px;
    text-align: center;
    border-bottom: 1px solid #f0f0f0;
  }
  .el-dialog__body {
    padding: 0;
  }
  .el-dialog__title {
    font-size: 18px;
    color: #333333;
    font-weight: normal;
  }

  .el-form-item__content {
    margin-left: 0 !important;
  }

  .enter-express-info {
    padding: 0 30px 30px 30px;
    .enter-express-tips{
      margin-bottom: 10px;
      color: #ff5a60;
      font-size: 12px;
      line-height: 1;
    }
    .express-select {
      display: block;
    }
    .express-to-address {
      padding: 15px 0 0 0;
      margin-bottom: 20px;
      .title {
        font-size: 14px;
        color: #333;
        line-height: 14px;
        margin-bottom: 15px;
      }
      .content {
        border-radius: 4px;
        background-color: #f9fcfe;
        padding: 15px 20px 13px 20px;
        font-size: 0;
        .location-icon {
          float:left;
          width: 56px;
          text-align: left;
          img {
            display: inline-block;
          }
        }
        .right-content {
          margin-left: 56px;
          .express-name {
            .name {
              color: #333;
              font-size: 14px;
              line-height: 14px;
            }
            .tel {
              color: #777;
              font-size: 14px;
              line-height: 14px;
            }
          }
          .express-detail {
            color: #777;
            font-size: 14px;
            line-height: 18px;
            margin-top: 10px;
          }
        }
      }
    }
    .dialog-footer {
      display: flex;
      justify-content: space-between;
      margin-top: 30px;
      button {
        width: 200px;
        height: 40px;
      }
    }
  }

  .express-type-select {
    position: relative;
    .express-type-tips{
      padding: 0 10px;
      background-color: #fef7f8;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 40px;
      display: flex;
      align-items: center;
      color: #ff5a60;
      font-size: 14px;
      line-height: 1;
      img{
        width: 16px;
        margin-right: 8px;
      }
    }
    .content {
      text-align: center;
      width: 200px;
      margin: 0 auto;
      .express-card {
        width: 200px;
        border: 1px solid #e3e3e3;
        border-radius: 4px;
        display: inline-block;
        padding: 20px 0 18px 16px;
        text-align: left;
        cursor: pointer;
        &:hover {
          border-color: #5e9be1;
          box-shadow: 0 4px 15px rgba(94, 155, 225, .2);
        }
      }
      .sf-pick-up {
        margin-top: 80px;
        font-size: 0;
        position: relative;
        .recomend {
          position: absolute;
          right: 0;
          top: 0;
        }
        .sf-content {
          margin-left: 10px;
        }
      }
      .self-send {
        margin-top: 60px;
        margin-bottom: 95px;
        font-size: 0;
        .self-send-content {
          margin-left: 10px;
        }
      }
      .inline-top {
        display: inline-block;
        vertical-align: middle;
      }
      .express-title {
        font-size: 14px;
        color: #333;
        line-height: 14px;
      }
      .express-content {
        font-size: 12px;
        color: #777;
        margin-top: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/express-type-choose.vue